import { SET_APP_SETTINGS } from '../actions/appSettings.actions'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_APP_SETTINGS:
      return action.settings
    default:
      return state
  }
}
